import type { DOMWindow } from 'jsdom';
import type { Config } from 'dompurify';
import { JSDOM } from 'jsdom';
import DOMPurify from 'dompurify';

import type { Sanitizer } from './sanitize.types';

class ServerSanitizer implements Sanitizer {
    private readonly window: DOMWindow;
    private readonly purify: ReturnType<typeof DOMPurify>;

    constructor() {
        const jsdom = new JSDOM('');
        this.window = jsdom.window as unknown as DOMWindow;
        this.purify = DOMPurify(this.window);
    }

    public sanitize(html: string, config: Config): string {
        return this.purify.sanitize(html, config);
    }
}

export const serverSanitizer: Sanitizer = new ServerSanitizer();
